import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { CheckCircle as CheckCircleIcon, ExitToApp as ExitToAppIcon } from '@material-ui/icons';

import { ButtonProps, Button } from './Button';

export interface ButtonCopyToClipboardProps extends Omit<ButtonProps, 'classes'> {
  text: string;
}

const ButtonCopyToClipboard: React.FC<ButtonCopyToClipboardProps> = ({ text, ...rest }) => {
  const [success, setSuccess] = useState(false);

  return (
    <CopyToClipboard
      text={text}
      onCopy={() => {
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 2000);
      }}
    >
      <Button icon={success ? <CheckCircleIcon fontSize="small" /> : <ExitToAppIcon fontSize="small" />} {...rest} />
    </CopyToClipboard>
  );
};

export default ButtonCopyToClipboard;
